/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../../common/runtime';
import type {
  AblyAuthSchema,
  Audience,
  AudiencePost,
  Call,
  Campaign,
  CampaignPatch,
  CampaignPostRequest,
  CampaignSettings,
  CampaignSettingsPatch,
  Contact,
  ContactPost,
  Csv,
  CsvPatch,
  CsvPatchAssertErrorResponse,
  CsvPostAssertErrorResponse,
  DialpadUser,
  EventLog,
  GlobalSettings,
  GlobalSettingsPatch,
  HookSchema,
  Lead,
  LeadItem,
  LeadItem1,
  LeadList,
  LeadListItem,
  LeadListPatch,
  LeadPatch,
  LeadPost,
  LoginSchema,
  Phone,
  PhoneCsv,
  PhoneCsvPatch,
  PhoneCsvPatchAssertErrorResponse,
  PhoneCsvPostAssertErrorResponse,
  PhonePatchAssertErrorResponse,
  PhonePost,
  PresignedUrl,
  Rule,
  RulePatch,
  RulePost,
  Sms,
  SmsPostRequest,
  Target,
  Worker,
  WorkerPatchRequest,
} from '../models/index';
import {
  AblyAuthSchemaFromJSON,
  AblyAuthSchemaToJSON,
  AudienceFromJSON,
  AudienceToJSON,
  AudiencePostFromJSON,
  AudiencePostToJSON,
  CallFromJSON,
  CallToJSON,
  CampaignFromJSON,
  CampaignToJSON,
  CampaignPatchFromJSON,
  CampaignPatchToJSON,
  CampaignPostRequestFromJSON,
  CampaignPostRequestToJSON,
  CampaignSettingsFromJSON,
  CampaignSettingsToJSON,
  CampaignSettingsPatchFromJSON,
  CampaignSettingsPatchToJSON,
  ContactFromJSON,
  ContactToJSON,
  ContactPostFromJSON,
  ContactPostToJSON,
  CsvFromJSON,
  CsvToJSON,
  CsvPatchFromJSON,
  CsvPatchToJSON,
  CsvPatchAssertErrorResponseFromJSON,
  CsvPatchAssertErrorResponseToJSON,
  CsvPostAssertErrorResponseFromJSON,
  CsvPostAssertErrorResponseToJSON,
  DialpadUserFromJSON,
  DialpadUserToJSON,
  EventLogFromJSON,
  EventLogToJSON,
  GlobalSettingsFromJSON,
  GlobalSettingsToJSON,
  GlobalSettingsPatchFromJSON,
  GlobalSettingsPatchToJSON,
  HookSchemaFromJSON,
  HookSchemaToJSON,
  LeadFromJSON,
  LeadToJSON,
  LeadItemFromJSON,
  LeadItemToJSON,
  LeadItem1FromJSON,
  LeadItem1ToJSON,
  LeadListFromJSON,
  LeadListToJSON,
  LeadListItemFromJSON,
  LeadListItemToJSON,
  LeadListPatchFromJSON,
  LeadListPatchToJSON,
  LeadPatchFromJSON,
  LeadPatchToJSON,
  LeadPostFromJSON,
  LeadPostToJSON,
  LoginSchemaFromJSON,
  LoginSchemaToJSON,
  PhoneFromJSON,
  PhoneToJSON,
  PhoneCsvFromJSON,
  PhoneCsvToJSON,
  PhoneCsvPatchFromJSON,
  PhoneCsvPatchToJSON,
  PhoneCsvPatchAssertErrorResponseFromJSON,
  PhoneCsvPatchAssertErrorResponseToJSON,
  PhoneCsvPostAssertErrorResponseFromJSON,
  PhoneCsvPostAssertErrorResponseToJSON,
  PhonePatchAssertErrorResponseFromJSON,
  PhonePatchAssertErrorResponseToJSON,
  PhonePostFromJSON,
  PhonePostToJSON,
  PresignedUrlFromJSON,
  PresignedUrlToJSON,
  RuleFromJSON,
  RuleToJSON,
  RulePatchFromJSON,
  RulePatchToJSON,
  RulePostFromJSON,
  RulePostToJSON,
  SmsFromJSON,
  SmsToJSON,
  SmsPostRequestFromJSON,
  SmsPostRequestToJSON,
  TargetFromJSON,
  TargetToJSON,
  WorkerFromJSON,
  WorkerToJSON,
  WorkerPatchRequestFromJSON,
  WorkerPatchRequestToJSON,
} from '../models/index';

export interface AddAudienceRequest {
  audiencePost?: AudiencePost;
}

export interface CallItemRequest {
  itemId: string;
  fake?: string;
}

export interface CreateCampaignRequest {
  campaignPostRequest?: CampaignPostRequest;
}

export interface CreateContactRequest {
  contactPost?: ContactPost;
}

export interface CreateLeadsRequest {
  leadPost?: LeadPost;
}

export interface CreatePhoneRequest {
  phonePost?: PhonePost;
}

export interface CreateRuleRequest {
  rulePost?: RulePost;
}

export interface DeleteAudienceRequest {
  audienceId: string;
}

export interface DeleteCampaignRequest {
  campaignId: string;
}

export interface DeleteCsvRequest {
  csvId: string;
}

export interface DeleteLeadListItemRequest {
  itemId: string;
}

export interface DeletePhoneRequest {
  e164: string;
}

export interface DeletePhoneCsvRequest {
  csvId: string;
}

export interface DeleteRuleRequest {
  ruleId: string;
}

export interface DuplicateCampaignRequest {
  campaignId: string;
}

export interface EditCampaignSettingsRequest {
  campaignSettingsId: string;
  campaignSettingsPatch?: CampaignSettingsPatch;
}

export interface GetAudienceRequest {
  audienceId: string;
}

export interface GetAudiencesRequest {
  count?: boolean;
  keysOnly?: boolean;
  total?: boolean;
  cursor?: string;
  offset?: number;
  limit?: number;
  targetIds?: string;
  state?: GetAudiencesStateEnum;
  search?: string;
  order?: string;
}

export interface GetCallsForTargetRequest {
  targetType: string;
  targetId: string;
  count?: boolean;
  keysOnly?: boolean;
  total?: boolean;
  cursor?: string;
  offset?: number;
  limit?: number;
}

export interface GetCallstatesRequest {
  count?: boolean;
  keysOnly?: boolean;
  total?: boolean;
  cursor?: string;
  offset?: number;
  limit?: number;
}

export interface GetCampaignRequest {
  campaignId: string;
}

export interface GetCampaignResultExportUrlRequest {
  campaignId: string;
}

export interface GetCampaignSettingsRequest {
  campaignSettingsId: string;
}

export interface GetCampaignsRequest {
  count?: boolean;
  keysOnly?: boolean;
  total?: boolean;
  cursor?: string;
  offset?: number;
  limit?: number;
  states?: string;
  state?: GetCampaignsStateEnum;
  targetIds?: string;
  search?: string;
  order?: string;
}

export interface GetContactRequest {
  contactId: string;
}

export interface GetContactsRequest {
  count?: boolean;
  keysOnly?: boolean;
  total?: boolean;
  cursor?: string;
  offset?: number;
  limit?: number;
}

export interface GetCsvRequest {
  csvId: string;
}

export interface GetCsvPresignedUrlRequest {
  csvId: string;
}

export interface GetCsvsRequest {
  count?: boolean;
  keysOnly?: boolean;
  total?: boolean;
  cursor?: string;
  offset?: number;
  limit?: number;
  targetIds?: string;
  tag?: GetCsvsTagEnum;
  states?: string;
  state?: GetCsvsStateEnum;
  search?: string;
  order?: string;
}

export interface GetEventLogsRequest {
  order?: string;
  subjectId?: string;
  campaignId?: string;
  tags?: string;
}

export interface GetGlobalSettingsRequest {
  companyId: number;
}

export interface GetLeadRequest {
  leadId: string;
}

export interface GetLeadItemRequest {
  itemId: string;
}

export interface GetLeadItemsRequest {
  listId: string;
  count?: boolean;
  keysOnly?: boolean;
  total?: boolean;
  cursor?: string;
  offset?: number;
  limit?: number;
  search?: string;
  order?: string;
}

export interface GetLeadListItemRequest {
  itemId: string;
}

export interface GetLeadListsRequest {
  count?: boolean;
  keysOnly?: boolean;
  total?: boolean;
  cursor?: string;
  offset?: number;
  limit?: number;
}

export interface GetLeadsRequest {
  count?: boolean;
  keysOnly?: boolean;
  total?: boolean;
  cursor?: string;
  offset?: number;
  limit?: number;
  order?: string;
  where?: string;
  audienceId?: string;
  csvId?: string;
  filters?: string;
  search?: string;
}

export interface GetListItemsRequest {
  listId: string;
  count?: boolean;
  keysOnly?: boolean;
  total?: boolean;
  cursor?: string;
  offset?: number;
  limit?: number;
  tag?: string;
}

export interface GetListListRequest {
  listId: string;
}

export interface GetModelsByKeysRequest {
  silent?: boolean;
  keys?: string;
}

export interface GetModelsByKeysOfKindRequest {
  kind: string;
  ids?: string;
  keys?: string;
}

export interface GetOperatorRequest {
  cached?: boolean;
}

export interface GetPhoneRequest {
  e164: string;
}

export interface GetPhoneCsvRequest {
  csvId: string;
}

export interface GetPhoneCsvsRequest {
  count?: boolean;
  keysOnly?: boolean;
  total?: boolean;
  cursor?: string;
  offset?: number;
  limit?: number;
  targetIds?: string;
  tag?: GetPhoneCsvsTagEnum;
  states?: string;
  state?: GetPhoneCsvsStateEnum;
  search?: string;
  order?: string;
}

export interface GetPhonesRequest {
  count?: boolean;
  keysOnly?: boolean;
  total?: boolean;
  cursor?: string;
  offset?: number;
  limit?: number;
  filters?: string;
  search?: string;
  order?: string;
}

export interface GetRuleRequest {
  ruleId: string;
}

export interface GetRulesRequest {
  count?: boolean;
  keysOnly?: boolean;
  total?: boolean;
  cursor?: string;
  offset?: number;
  limit?: number;
  flowId?: string;
  campaignId?: string;
}

export interface GetSmsForTargetRequest {
  targetType: string;
  targetId: string;
  count?: boolean;
  keysOnly?: boolean;
  total?: boolean;
  cursor?: string;
  offset?: number;
  limit?: number;
}

export interface GetVarsInfoRequest {
  campaignId: string;
}

export interface GetWorkerRequest {
  workerId: string;
}

export interface GetWorkersRequest {
  campaignId?: string;
  tags?: string;
}

export interface HookCallbackRequest {
  campaignId?: string;
}

export interface SmsItemRequest {
  smsPostRequest?: SmsPostRequest;
}

export interface StartCampaignResultExportRequest {
  campaignId: string;
}

export interface UpdateCampaignRequest {
  campaignId: string;
  campaignPatch?: CampaignPatch;
}

export interface UpdateCsvRequest {
  csvId: string;
  csvPatch?: CsvPatch;
}

export interface UpdateGlobalSettingsRequest {
  companyId: number;
  globalSettingsPatch?: GlobalSettingsPatch;
}

export interface UpdateLeadRequest {
  leadId: string;
  leadPatch?: LeadPatch;
}

export interface UpdateLeadListRequest {
  listId: string;
  leadListPatch?: LeadListPatch;
}

export interface UpdatePhoneRequest {
  e164: string;
  phonePost?: PhonePost;
}

export interface UpdatePhoneCsvRequest {
  csvId: string;
  phoneCsvPatch?: PhoneCsvPatch;
}

export interface UpdateRuleRequest {
  ruleId: string;
  rulePatch?: RulePatch;
}

export interface UpdateWorkerRequest {
  workerId: string;
  workerPatchRequest?: WorkerPatchRequest;
}

export interface UploadCsvRequest {
  file?: Blob;
  name?: string;
}

export interface UploadPhoneCsvRequest {
  file?: Blob;
  name?: string;
}

/**
 *
 */
export class DappApiApi extends runtime.BaseAPI {
  /**
   * Add an Audience
   * Add an Audience
   */
  async addAudienceRaw(
    requestParameters: AddAudienceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Audience>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/api/audience`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: AudiencePostToJSON(requestParameters['audiencePost']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AudienceFromJSON(jsonValue),
    );
  }

  /**
   * Add an Audience
   * Add an Audience
   */
  async addAudience(
    requestParameters: AddAudienceRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Audience> {
    const response = await this.addAudienceRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Call an Item
   * Call an Item
   */
  async callItemRaw(
    requestParameters: CallItemRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<LeadListItem>> {
    if (requestParameters['itemId'] == null) {
      throw new runtime.RequiredError(
        'itemId',
        'Required parameter "itemId" was null or undefined when calling callItem().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['fake'] != null) {
      queryParameters['fake'] = requestParameters['fake'];
    }

    if (requestParameters['itemId'] != null) {
      queryParameters['item_id'] = requestParameters['itemId'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/call`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      LeadListItemFromJSON(jsonValue),
    );
  }

  /**
   * Call an Item
   * Call an Item
   */
  async callItem(
    requestParameters: CallItemRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<LeadListItem> {
    const response = await this.callItemRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Create a new Campaign associated with a Dialpad Target
   * Create Campaign
   */
  async createCampaignRaw(
    requestParameters: CreateCampaignRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Campaign>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/api/campaign`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CampaignPostRequestToJSON(
          requestParameters['campaignPostRequest'],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CampaignFromJSON(jsonValue),
    );
  }

  /**
   * Create a new Campaign associated with a Dialpad Target
   * Create Campaign
   */
  async createCampaign(
    requestParameters: CreateCampaignRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Campaign> {
    const response = await this.createCampaignRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Create a Contact
   * Create a Contact
   */
  async createContactRaw(
    requestParameters: CreateContactRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Contact>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/api/contact`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: ContactPostToJSON(requestParameters['contactPost']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ContactFromJSON(jsonValue),
    );
  }

  /**
   * Create a Contact
   * Create a Contact
   */
  async createContact(
    requestParameters: CreateContactRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Contact> {
    const response = await this.createContactRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Create a Lead, and optionally add it to a campaign
   * Create Lead
   */
  async createLeadsRaw(
    requestParameters: CreateLeadsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Lead>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/api/lead`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: LeadPostToJSON(requestParameters['leadPost']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      LeadFromJSON(jsonValue),
    );
  }

  /**
   * Create a Lead, and optionally add it to a campaign
   * Create Lead
   */
  async createLeads(
    requestParameters: CreateLeadsRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Lead> {
    const response = await this.createLeadsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Create a Phone entry to the company DNC/DNT table
   * Create a Phone
   */
  async createPhoneRaw(
    requestParameters: CreatePhoneRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Phone>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/api/phone`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: PhonePostToJSON(requestParameters['phonePost']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PhoneFromJSON(jsonValue),
    );
  }

  /**
   * Create a Phone entry to the company DNC/DNT table
   * Create a Phone
   */
  async createPhone(
    requestParameters: CreatePhoneRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Phone> {
    const response = await this.createPhoneRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Create a rule for a campaign
   * Create rule for a campaign
   */
  async createRuleRaw(
    requestParameters: CreateRuleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Rule>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/api/rule`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: RulePostToJSON(requestParameters['rulePost']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RuleFromJSON(jsonValue),
    );
  }

  /**
   * Create a rule for a campaign
   * Create rule for a campaign
   */
  async createRule(
    requestParameters: CreateRuleRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Rule> {
    const response = await this.createRuleRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Delete a Audience
   * Delete an Audience
   */
  async deleteAudienceRaw(
    requestParameters: DeleteAudienceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['audienceId'] == null) {
      throw new runtime.RequiredError(
        'audienceId',
        'Required parameter "audienceId" was null or undefined when calling deleteAudience().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/audience/{audience_id}`.replace(
          `{${'audience_id'}}`,
          encodeURIComponent(String(requestParameters['audienceId'])),
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete a Audience
   * Delete an Audience
   */
  async deleteAudience(
    requestParameters: DeleteAudienceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.deleteAudienceRaw(requestParameters, initOverrides);
  }

  /**
   * Delete a campaign entity
   * Delete Campaign
   */
  async deleteCampaignRaw(
    requestParameters: DeleteCampaignRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['campaignId'] == null) {
      throw new runtime.RequiredError(
        'campaignId',
        'Required parameter "campaignId" was null or undefined when calling deleteCampaign().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/campaign/{campaign_id}`.replace(
          `{${'campaign_id'}}`,
          encodeURIComponent(String(requestParameters['campaignId'])),
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete a campaign entity
   * Delete Campaign
   */
  async deleteCampaign(
    requestParameters: DeleteCampaignRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.deleteCampaignRaw(requestParameters, initOverrides);
  }

  /**
   * Delete a Csv Entity
   * Delete CSV
   */
  async deleteCsvRaw(
    requestParameters: DeleteCsvRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['csvId'] == null) {
      throw new runtime.RequiredError(
        'csvId',
        'Required parameter "csvId" was null or undefined when calling deleteCsv().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/csv/{csv_id}`.replace(
          `{${'csv_id'}}`,
          encodeURIComponent(String(requestParameters['csvId'])),
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete a Csv Entity
   * Delete CSV
   */
  async deleteCsv(
    requestParameters: DeleteCsvRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.deleteCsvRaw(requestParameters, initOverrides);
  }

  /**
   * Delete a LeadListItem
   * Delete a LeadListItem
   */
  async deleteLeadListItemRaw(
    requestParameters: DeleteLeadListItemRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['itemId'] == null) {
      throw new runtime.RequiredError(
        'itemId',
        'Required parameter "itemId" was null or undefined when calling deleteLeadListItem().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/item/{item_id}`.replace(
          `{${'item_id'}}`,
          encodeURIComponent(String(requestParameters['itemId'])),
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete a LeadListItem
   * Delete a LeadListItem
   */
  async deleteLeadListItem(
    requestParameters: DeleteLeadListItemRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.deleteLeadListItemRaw(requestParameters, initOverrides);
  }

  /**
   * Delete a Phone Entity
   * Delete Phone
   */
  async deletePhoneRaw(
    requestParameters: DeletePhoneRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['e164'] == null) {
      throw new runtime.RequiredError(
        'e164',
        'Required parameter "e164" was null or undefined when calling deletePhone().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/phone/{e164}`.replace(
          `{${'e164'}}`,
          encodeURIComponent(String(requestParameters['e164'])),
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete a Phone Entity
   * Delete Phone
   */
  async deletePhone(
    requestParameters: DeletePhoneRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.deletePhoneRaw(requestParameters, initOverrides);
  }

  /**
   * Delete a Phone Csv Entity
   * Delete Phone CSV
   */
  async deletePhoneCsvRaw(
    requestParameters: DeletePhoneCsvRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['csvId'] == null) {
      throw new runtime.RequiredError(
        'csvId',
        'Required parameter "csvId" was null or undefined when calling deletePhoneCsv().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/phonecsv/{csv_id}`.replace(
          `{${'csv_id'}}`,
          encodeURIComponent(String(requestParameters['csvId'])),
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete a Phone Csv Entity
   * Delete Phone CSV
   */
  async deletePhoneCsv(
    requestParameters: DeletePhoneCsvRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.deletePhoneCsvRaw(requestParameters, initOverrides);
  }

  /**
   * Delete a rule belonging to a campaign with campaign_id
   * Delete a rule
   */
  async deleteRuleRaw(
    requestParameters: DeleteRuleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['ruleId'] == null) {
      throw new runtime.RequiredError(
        'ruleId',
        'Required parameter "ruleId" was null or undefined when calling deleteRule().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/rule/{rule_id}`.replace(
          `{${'rule_id'}}`,
          encodeURIComponent(String(requestParameters['ruleId'])),
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete a rule belonging to a campaign with campaign_id
   * Delete a rule
   */
  async deleteRule(
    requestParameters: DeleteRuleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.deleteRuleRaw(requestParameters, initOverrides);
  }

  /**
   * Create a new campaign from an existing one
   * Duplicate a Campaign
   */
  async duplicateCampaignRaw(
    requestParameters: DuplicateCampaignRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Campaign>> {
    if (requestParameters['campaignId'] == null) {
      throw new runtime.RequiredError(
        'campaignId',
        'Required parameter "campaignId" was null or undefined when calling duplicateCampaign().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/campaign/{campaign_id}`.replace(
          `{${'campaign_id'}}`,
          encodeURIComponent(String(requestParameters['campaignId'])),
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CampaignFromJSON(jsonValue),
    );
  }

  /**
   * Create a new campaign from an existing one
   * Duplicate a Campaign
   */
  async duplicateCampaign(
    requestParameters: DuplicateCampaignRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Campaign> {
    const response = await this.duplicateCampaignRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Edit a Campaign Settings object
   * Edit Settings for a Campaign
   */
  async editCampaignSettingsRaw(
    requestParameters: EditCampaignSettingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CampaignSettings>> {
    if (requestParameters['campaignSettingsId'] == null) {
      throw new runtime.RequiredError(
        'campaignSettingsId',
        'Required parameter "campaignSettingsId" was null or undefined when calling editCampaignSettings().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/api/campaignsettings/{campaign_settings_id}`.replace(
          `{${'campaign_settings_id'}}`,
          encodeURIComponent(String(requestParameters['campaignSettingsId'])),
        ),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: CampaignSettingsPatchToJSON(
          requestParameters['campaignSettingsPatch'],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CampaignSettingsFromJSON(jsonValue),
    );
  }

  /**
   * Edit a Campaign Settings object
   * Edit Settings for a Campaign
   */
  async editCampaignSettings(
    requestParameters: EditCampaignSettingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CampaignSettings> {
    const response = await this.editCampaignSettingsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Auth endpoint for ably js client
   * Ably Auth Endpoint
   */
  async getAblyTokenRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<AblyAuthSchema>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/ably`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AblyAuthSchemaFromJSON(jsonValue),
    );
  }

  /**
   * Auth endpoint for ably js client
   * Ably Auth Endpoint
   */
  async getAblyToken(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<AblyAuthSchema> {
    const response = await this.getAblyTokenRaw(initOverrides);
    return await response.value();
  }

  /**
   * Get a single Audience by id
   * Get Audience
   */
  async getAudienceRaw(
    requestParameters: GetAudienceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Audience>> {
    if (requestParameters['audienceId'] == null) {
      throw new runtime.RequiredError(
        'audienceId',
        'Required parameter "audienceId" was null or undefined when calling getAudience().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/audience/{audience_id}`.replace(
          `{${'audience_id'}}`,
          encodeURIComponent(String(requestParameters['audienceId'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AudienceFromJSON(jsonValue),
    );
  }

  /**
   * Get a single Audience by id
   * Get Audience
   */
  async getAudience(
    requestParameters: GetAudienceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Audience> {
    const response = await this.getAudienceRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Get a list of Audiences
   * Get Audiences
   */
  async getAudiencesRaw(
    requestParameters: GetAudiencesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<Audience>>> {
    const queryParameters: any = {};

    if (requestParameters['count'] != null) {
      queryParameters['count'] = requestParameters['count'];
    }

    if (requestParameters['keysOnly'] != null) {
      queryParameters['keys_only'] = requestParameters['keysOnly'];
    }

    if (requestParameters['total'] != null) {
      queryParameters['total'] = requestParameters['total'];
    }

    if (requestParameters['cursor'] != null) {
      queryParameters['cursor'] = requestParameters['cursor'];
    }

    if (requestParameters['offset'] != null) {
      queryParameters['offset'] = requestParameters['offset'];
    }

    if (requestParameters['limit'] != null) {
      queryParameters['limit'] = requestParameters['limit'];
    }

    if (requestParameters['targetIds'] != null) {
      queryParameters['target_ids'] = requestParameters['targetIds'];
    }

    if (requestParameters['state'] != null) {
      queryParameters['state'] = requestParameters['state'];
    }

    if (requestParameters['search'] != null) {
      queryParameters['search'] = requestParameters['search'];
    }

    if (requestParameters['order'] != null) {
      queryParameters['order'] = requestParameters['order'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/audience`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(AudienceFromJSON),
    );
  }

  /**
   * Get a list of Audiences
   * Get Audiences
   */
  async getAudiences(
    requestParameters: GetAudiencesRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<Audience>> {
    const response = await this.getAudiencesRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * DEBUG: Get a list of recent calls given a Target
   * Get Calls for a Target
   */
  async getCallsForTargetRaw(
    requestParameters: GetCallsForTargetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<Call>>> {
    if (requestParameters['targetType'] == null) {
      throw new runtime.RequiredError(
        'targetType',
        'Required parameter "targetType" was null or undefined when calling getCallsForTarget().',
      );
    }

    if (requestParameters['targetId'] == null) {
      throw new runtime.RequiredError(
        'targetId',
        'Required parameter "targetId" was null or undefined when calling getCallsForTarget().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['count'] != null) {
      queryParameters['count'] = requestParameters['count'];
    }

    if (requestParameters['keysOnly'] != null) {
      queryParameters['keys_only'] = requestParameters['keysOnly'];
    }

    if (requestParameters['total'] != null) {
      queryParameters['total'] = requestParameters['total'];
    }

    if (requestParameters['cursor'] != null) {
      queryParameters['cursor'] = requestParameters['cursor'];
    }

    if (requestParameters['offset'] != null) {
      queryParameters['offset'] = requestParameters['offset'];
    }

    if (requestParameters['limit'] != null) {
      queryParameters['limit'] = requestParameters['limit'];
    }

    if (requestParameters['targetType'] != null) {
      queryParameters['target_type'] = requestParameters['targetType'];
    }

    if (requestParameters['targetId'] != null) {
      queryParameters['target_id'] = requestParameters['targetId'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/call`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CallFromJSON),
    );
  }

  /**
   * DEBUG: Get a list of recent calls given a Target
   * Get Calls for a Target
   */
  async getCallsForTarget(
    requestParameters: GetCallsForTargetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<Call>> {
    const response = await this.getCallsForTargetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Call State-View
   */
  async getCallstatesRaw(
    requestParameters: GetCallstatesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    const queryParameters: any = {};

    if (requestParameters['count'] != null) {
      queryParameters['count'] = requestParameters['count'];
    }

    if (requestParameters['keysOnly'] != null) {
      queryParameters['keys_only'] = requestParameters['keysOnly'];
    }

    if (requestParameters['total'] != null) {
      queryParameters['total'] = requestParameters['total'];
    }

    if (requestParameters['cursor'] != null) {
      queryParameters['cursor'] = requestParameters['cursor'];
    }

    if (requestParameters['offset'] != null) {
      queryParameters['offset'] = requestParameters['offset'];
    }

    if (requestParameters['limit'] != null) {
      queryParameters['limit'] = requestParameters['limit'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/callstate`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Call State-View
   */
  async getCallstates(
    requestParameters: GetCallstatesRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.getCallstatesRaw(requestParameters, initOverrides);
  }

  /**
   * Get an individual Campaign
   * Get Campaign
   */
  async getCampaignRaw(
    requestParameters: GetCampaignRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Campaign>> {
    if (requestParameters['campaignId'] == null) {
      throw new runtime.RequiredError(
        'campaignId',
        'Required parameter "campaignId" was null or undefined when calling getCampaign().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/campaign/{campaign_id}`.replace(
          `{${'campaign_id'}}`,
          encodeURIComponent(String(requestParameters['campaignId'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CampaignFromJSON(jsonValue),
    );
  }

  /**
   * Get an individual Campaign
   * Get Campaign
   */
  async getCampaign(
    requestParameters: GetCampaignRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Campaign> {
    const response = await this.getCampaignRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Get a presigned url to download campaign result export
   * Get campaign result export url
   */
  async getCampaignResultExportUrlRaw(
    requestParameters: GetCampaignResultExportUrlRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PresignedUrl>> {
    if (requestParameters['campaignId'] == null) {
      throw new runtime.RequiredError(
        'campaignId',
        'Required parameter "campaignId" was null or undefined when calling getCampaignResultExportUrl().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/campaign_export/{campaign_id}`.replace(
          `{${'campaign_id'}}`,
          encodeURIComponent(String(requestParameters['campaignId'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PresignedUrlFromJSON(jsonValue),
    );
  }

  /**
   * Get a presigned url to download campaign result export
   * Get campaign result export url
   */
  async getCampaignResultExportUrl(
    requestParameters: GetCampaignResultExportUrlRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PresignedUrl> {
    const response = await this.getCampaignResultExportUrlRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Settings for a Campaign
   * Get a Campaign Settings object
   */
  async getCampaignSettingsRaw(
    requestParameters: GetCampaignSettingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CampaignSettings>> {
    if (requestParameters['campaignSettingsId'] == null) {
      throw new runtime.RequiredError(
        'campaignSettingsId',
        'Required parameter "campaignSettingsId" was null or undefined when calling getCampaignSettings().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/campaignsettings/{campaign_settings_id}`.replace(
          `{${'campaign_settings_id'}}`,
          encodeURIComponent(String(requestParameters['campaignSettingsId'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CampaignSettingsFromJSON(jsonValue),
    );
  }

  /**
   * Settings for a Campaign
   * Get a Campaign Settings object
   */
  async getCampaignSettings(
    requestParameters: GetCampaignSettingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CampaignSettings> {
    const response = await this.getCampaignSettingsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Fetch a list of Campaign entities assoicated with the company
   * List of Campaigns
   */
  async getCampaignsRaw(
    requestParameters: GetCampaignsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<Campaign>>> {
    const queryParameters: any = {};

    if (requestParameters['count'] != null) {
      queryParameters['count'] = requestParameters['count'];
    }

    if (requestParameters['keysOnly'] != null) {
      queryParameters['keys_only'] = requestParameters['keysOnly'];
    }

    if (requestParameters['total'] != null) {
      queryParameters['total'] = requestParameters['total'];
    }

    if (requestParameters['cursor'] != null) {
      queryParameters['cursor'] = requestParameters['cursor'];
    }

    if (requestParameters['offset'] != null) {
      queryParameters['offset'] = requestParameters['offset'];
    }

    if (requestParameters['limit'] != null) {
      queryParameters['limit'] = requestParameters['limit'];
    }

    if (requestParameters['states'] != null) {
      queryParameters['states'] = requestParameters['states'];
    }

    if (requestParameters['state'] != null) {
      queryParameters['state'] = requestParameters['state'];
    }

    if (requestParameters['targetIds'] != null) {
      queryParameters['target_ids'] = requestParameters['targetIds'];
    }

    if (requestParameters['search'] != null) {
      queryParameters['search'] = requestParameters['search'];
    }

    if (requestParameters['order'] != null) {
      queryParameters['order'] = requestParameters['order'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/campaign`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CampaignFromJSON),
    );
  }

  /**
   * Fetch a list of Campaign entities assoicated with the company
   * List of Campaigns
   */
  async getCampaigns(
    requestParameters: GetCampaignsRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<Campaign>> {
    const response = await this.getCampaignsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Get a Contact
   * Get a Contact
   */
  async getContactRaw(
    requestParameters: GetContactRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Contact>> {
    if (requestParameters['contactId'] == null) {
      throw new runtime.RequiredError(
        'contactId',
        'Required parameter "contactId" was null or undefined when calling getContact().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/contact/{contact_id}`.replace(
          `{${'contact_id'}}`,
          encodeURIComponent(String(requestParameters['contactId'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ContactFromJSON(jsonValue),
    );
  }

  /**
   * Get a Contact
   * Get a Contact
   */
  async getContact(
    requestParameters: GetContactRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Contact> {
    const response = await this.getContactRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Get a list of Contacts
   * Get Contacts
   */
  async getContactsRaw(
    requestParameters: GetContactsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<Contact>>> {
    const queryParameters: any = {};

    if (requestParameters['count'] != null) {
      queryParameters['count'] = requestParameters['count'];
    }

    if (requestParameters['keysOnly'] != null) {
      queryParameters['keys_only'] = requestParameters['keysOnly'];
    }

    if (requestParameters['total'] != null) {
      queryParameters['total'] = requestParameters['total'];
    }

    if (requestParameters['cursor'] != null) {
      queryParameters['cursor'] = requestParameters['cursor'];
    }

    if (requestParameters['offset'] != null) {
      queryParameters['offset'] = requestParameters['offset'];
    }

    if (requestParameters['limit'] != null) {
      queryParameters['limit'] = requestParameters['limit'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/contact`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(ContactFromJSON),
    );
  }

  /**
   * Get a list of Contacts
   * Get Contacts
   */
  async getContacts(
    requestParameters: GetContactsRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<Contact>> {
    const response = await this.getContactsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Get an individual CSV entity
   * Get CSV
   */
  async getCsvRaw(
    requestParameters: GetCsvRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Csv>> {
    if (requestParameters['csvId'] == null) {
      throw new runtime.RequiredError(
        'csvId',
        'Required parameter "csvId" was null or undefined when calling getCsv().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/csv/{csv_id}`.replace(
          `{${'csv_id'}}`,
          encodeURIComponent(String(requestParameters['csvId'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CsvFromJSON(jsonValue),
    );
  }

  /**
   * Get an individual CSV entity
   * Get CSV
   */
  async getCsv(
    requestParameters: GetCsvRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Csv> {
    const response = await this.getCsvRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Generate a presigned url to download a CSV file with TTL=30s
   */
  async getCsvPresignedUrlRaw(
    requestParameters: GetCsvPresignedUrlRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PresignedUrl>> {
    if (requestParameters['csvId'] == null) {
      throw new runtime.RequiredError(
        'csvId',
        'Required parameter "csvId" was null or undefined when calling getCsvPresignedUrl().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/csv_presigned_url/{csv_id}`.replace(
          `{${'csv_id'}}`,
          encodeURIComponent(String(requestParameters['csvId'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PresignedUrlFromJSON(jsonValue),
    );
  }

  /**
   * Generate a presigned url to download a CSV file with TTL=30s
   */
  async getCsvPresignedUrl(
    requestParameters: GetCsvPresignedUrlRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PresignedUrl> {
    const response = await this.getCsvPresignedUrlRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Get a list of Csv entities
   * Get List of CSVs
   */
  async getCsvsRaw(
    requestParameters: GetCsvsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<Csv>>> {
    const queryParameters: any = {};

    if (requestParameters['count'] != null) {
      queryParameters['count'] = requestParameters['count'];
    }

    if (requestParameters['keysOnly'] != null) {
      queryParameters['keys_only'] = requestParameters['keysOnly'];
    }

    if (requestParameters['total'] != null) {
      queryParameters['total'] = requestParameters['total'];
    }

    if (requestParameters['cursor'] != null) {
      queryParameters['cursor'] = requestParameters['cursor'];
    }

    if (requestParameters['offset'] != null) {
      queryParameters['offset'] = requestParameters['offset'];
    }

    if (requestParameters['limit'] != null) {
      queryParameters['limit'] = requestParameters['limit'];
    }

    if (requestParameters['targetIds'] != null) {
      queryParameters['target_ids'] = requestParameters['targetIds'];
    }

    if (requestParameters['tag'] != null) {
      queryParameters['tag'] = requestParameters['tag'];
    }

    if (requestParameters['states'] != null) {
      queryParameters['states'] = requestParameters['states'];
    }

    if (requestParameters['state'] != null) {
      queryParameters['state'] = requestParameters['state'];
    }

    if (requestParameters['search'] != null) {
      queryParameters['search'] = requestParameters['search'];
    }

    if (requestParameters['order'] != null) {
      queryParameters['order'] = requestParameters['order'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/csv`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CsvFromJSON),
    );
  }

  /**
   * Get a list of Csv entities
   * Get List of CSVs
   */
  async getCsvs(
    requestParameters: GetCsvsRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<Csv>> {
    const response = await this.getCsvsRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * JSON representation of the logged in user
   * The Current User
   */
  async getCurrentUserRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<DialpadUser>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/user/me`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      DialpadUserFromJSON(jsonValue),
    );
  }

  /**
   * JSON representation of the logged in user
   * The Current User
   */
  async getCurrentUser(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<DialpadUser> {
    const response = await this.getCurrentUserRaw(initOverrides);
    return await response.value();
  }

  /**
   * Get a list of EventLog\'s for a Campaign
   * Get EventLogs
   */
  async getEventLogsRaw(
    requestParameters: GetEventLogsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<EventLog>>> {
    const queryParameters: any = {};

    if (requestParameters['order'] != null) {
      queryParameters['order'] = requestParameters['order'];
    }

    if (requestParameters['subjectId'] != null) {
      queryParameters['subject_id'] = requestParameters['subjectId'];
    }

    if (requestParameters['campaignId'] != null) {
      queryParameters['campaign_id'] = requestParameters['campaignId'];
    }

    if (requestParameters['tags'] != null) {
      queryParameters['tags'] = requestParameters['tags'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/event`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(EventLogFromJSON),
    );
  }

  /**
   * Get a list of EventLog\'s for a Campaign
   * Get EventLogs
   */
  async getEventLogs(
    requestParameters: GetEventLogsRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<EventLog>> {
    const response = await this.getEventLogsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Get company GlobalSettings with only modified fields
   * Get Company GlobalSettings
   */
  async getGlobalSettingsRaw(
    requestParameters: GetGlobalSettingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<GlobalSettings>> {
    if (requestParameters['companyId'] == null) {
      throw new runtime.RequiredError(
        'companyId',
        'Required parameter "companyId" was null or undefined when calling getGlobalSettings().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/globalsettings/{company_id}`.replace(
          `{${'company_id'}}`,
          encodeURIComponent(String(requestParameters['companyId'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GlobalSettingsFromJSON(jsonValue),
    );
  }

  /**
   * Get company GlobalSettings with only modified fields
   * Get Company GlobalSettings
   */
  async getGlobalSettings(
    requestParameters: GetGlobalSettingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<GlobalSettings> {
    const response = await this.getGlobalSettingsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Get an individual lead
   * Get Lead
   */
  async getLeadRaw(
    requestParameters: GetLeadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Lead>> {
    if (requestParameters['leadId'] == null) {
      throw new runtime.RequiredError(
        'leadId',
        'Required parameter "leadId" was null or undefined when calling getLead().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/lead/{lead_id}`.replace(
          `{${'lead_id'}}`,
          encodeURIComponent(String(requestParameters['leadId'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      LeadFromJSON(jsonValue),
    );
  }

  /**
   * Get an individual lead
   * Get Lead
   */
  async getLead(
    requestParameters: GetLeadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Lead> {
    const response = await this.getLeadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Get a LeadItem
   * Get LeadItem
   */
  async getLeadItemRaw(
    requestParameters: GetLeadItemRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<LeadItem1>> {
    if (requestParameters['itemId'] == null) {
      throw new runtime.RequiredError(
        'itemId',
        'Required parameter "itemId" was null or undefined when calling getLeadItem().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/leaditem/{item_id}`.replace(
          `{${'item_id'}}`,
          encodeURIComponent(String(requestParameters['itemId'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      LeadItem1FromJSON(jsonValue),
    );
  }

  /**
   * Get a LeadItem
   * Get LeadItem
   */
  async getLeadItem(
    requestParameters: GetLeadItemRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<LeadItem1> {
    const response = await this.getLeadItemRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * A mashup api to return a sortable, searchable list for campaign details
   * List of LeadListItem + Lead
   */
  async getLeadItemsRaw(
    requestParameters: GetLeadItemsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<LeadItem>>> {
    if (requestParameters['listId'] == null) {
      throw new runtime.RequiredError(
        'listId',
        'Required parameter "listId" was null or undefined when calling getLeadItems().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['count'] != null) {
      queryParameters['count'] = requestParameters['count'];
    }

    if (requestParameters['keysOnly'] != null) {
      queryParameters['keys_only'] = requestParameters['keysOnly'];
    }

    if (requestParameters['total'] != null) {
      queryParameters['total'] = requestParameters['total'];
    }

    if (requestParameters['cursor'] != null) {
      queryParameters['cursor'] = requestParameters['cursor'];
    }

    if (requestParameters['offset'] != null) {
      queryParameters['offset'] = requestParameters['offset'];
    }

    if (requestParameters['limit'] != null) {
      queryParameters['limit'] = requestParameters['limit'];
    }

    if (requestParameters['search'] != null) {
      queryParameters['search'] = requestParameters['search'];
    }

    if (requestParameters['order'] != null) {
      queryParameters['order'] = requestParameters['order'];
    }

    if (requestParameters['listId'] != null) {
      queryParameters['list_id'] = requestParameters['listId'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/leaditem`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(LeadItemFromJSON),
    );
  }

  /**
   * A mashup api to return a sortable, searchable list for campaign details
   * List of LeadListItem + Lead
   */
  async getLeadItems(
    requestParameters: GetLeadItemsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<LeadItem>> {
    const response = await this.getLeadItemsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Get a single LeadListItem by id
   * Get a LeadListItem
   */
  async getLeadListItemRaw(
    requestParameters: GetLeadListItemRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<LeadListItem>> {
    if (requestParameters['itemId'] == null) {
      throw new runtime.RequiredError(
        'itemId',
        'Required parameter "itemId" was null or undefined when calling getLeadListItem().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/item/{item_id}`.replace(
          `{${'item_id'}}`,
          encodeURIComponent(String(requestParameters['itemId'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      LeadListItemFromJSON(jsonValue),
    );
  }

  /**
   * Get a single LeadListItem by id
   * Get a LeadListItem
   */
  async getLeadListItem(
    requestParameters: GetLeadListItemRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<LeadListItem> {
    const response = await this.getLeadListItemRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Get a list of LeadLists
   * List of LeadList
   */
  async getLeadListsRaw(
    requestParameters: GetLeadListsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<LeadList>>> {
    const queryParameters: any = {};

    if (requestParameters['count'] != null) {
      queryParameters['count'] = requestParameters['count'];
    }

    if (requestParameters['keysOnly'] != null) {
      queryParameters['keys_only'] = requestParameters['keysOnly'];
    }

    if (requestParameters['total'] != null) {
      queryParameters['total'] = requestParameters['total'];
    }

    if (requestParameters['cursor'] != null) {
      queryParameters['cursor'] = requestParameters['cursor'];
    }

    if (requestParameters['offset'] != null) {
      queryParameters['offset'] = requestParameters['offset'];
    }

    if (requestParameters['limit'] != null) {
      queryParameters['limit'] = requestParameters['limit'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/list`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(LeadListFromJSON),
    );
  }

  /**
   * Get a list of LeadLists
   * List of LeadList
   */
  async getLeadLists(
    requestParameters: GetLeadListsRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<LeadList>> {
    const response = await this.getLeadListsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Get a list of Leads, including searching for leads by filter, sql, and ai
   * List of Leads
   */
  async getLeadsRaw(
    requestParameters: GetLeadsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<Lead>>> {
    const queryParameters: any = {};

    if (requestParameters['count'] != null) {
      queryParameters['count'] = requestParameters['count'];
    }

    if (requestParameters['keysOnly'] != null) {
      queryParameters['keys_only'] = requestParameters['keysOnly'];
    }

    if (requestParameters['total'] != null) {
      queryParameters['total'] = requestParameters['total'];
    }

    if (requestParameters['cursor'] != null) {
      queryParameters['cursor'] = requestParameters['cursor'];
    }

    if (requestParameters['offset'] != null) {
      queryParameters['offset'] = requestParameters['offset'];
    }

    if (requestParameters['limit'] != null) {
      queryParameters['limit'] = requestParameters['limit'];
    }

    if (requestParameters['order'] != null) {
      queryParameters['order'] = requestParameters['order'];
    }

    if (requestParameters['where'] != null) {
      queryParameters['where'] = requestParameters['where'];
    }

    if (requestParameters['audienceId'] != null) {
      queryParameters['audience_id'] = requestParameters['audienceId'];
    }

    if (requestParameters['csvId'] != null) {
      queryParameters['csv_id'] = requestParameters['csvId'];
    }

    if (requestParameters['filters'] != null) {
      queryParameters['filters'] = requestParameters['filters'];
    }

    if (requestParameters['search'] != null) {
      queryParameters['search'] = requestParameters['search'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/lead`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(LeadFromJSON),
    );
  }

  /**
   * Get a list of Leads, including searching for leads by filter, sql, and ai
   * List of Leads
   */
  async getLeads(
    requestParameters: GetLeadsRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<Lead>> {
    const response = await this.getLeadsRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * List of LeadListItem belonging to a LeadList.list_id
   * List of LeadListItem
   */
  async getListItemsRaw(
    requestParameters: GetListItemsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<LeadListItem>>> {
    if (requestParameters['listId'] == null) {
      throw new runtime.RequiredError(
        'listId',
        'Required parameter "listId" was null or undefined when calling getListItems().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['count'] != null) {
      queryParameters['count'] = requestParameters['count'];
    }

    if (requestParameters['keysOnly'] != null) {
      queryParameters['keys_only'] = requestParameters['keysOnly'];
    }

    if (requestParameters['total'] != null) {
      queryParameters['total'] = requestParameters['total'];
    }

    if (requestParameters['cursor'] != null) {
      queryParameters['cursor'] = requestParameters['cursor'];
    }

    if (requestParameters['offset'] != null) {
      queryParameters['offset'] = requestParameters['offset'];
    }

    if (requestParameters['limit'] != null) {
      queryParameters['limit'] = requestParameters['limit'];
    }

    if (requestParameters['tag'] != null) {
      queryParameters['tag'] = requestParameters['tag'];
    }

    if (requestParameters['listId'] != null) {
      queryParameters['list_id'] = requestParameters['listId'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/item`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(LeadListItemFromJSON),
    );
  }

  /**
   * List of LeadListItem belonging to a LeadList.list_id
   * List of LeadListItem
   */
  async getListItems(
    requestParameters: GetListItemsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<LeadListItem>> {
    const response = await this.getListItemsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Get a LeadList
   * Get a LeadList
   */
  async getListListRaw(
    requestParameters: GetListListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<LeadList>> {
    if (requestParameters['listId'] == null) {
      throw new runtime.RequiredError(
        'listId',
        'Required parameter "listId" was null or undefined when calling getListList().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/list/{list_id}`.replace(
          `{${'list_id'}}`,
          encodeURIComponent(String(requestParameters['listId'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      LeadListFromJSON(jsonValue),
    );
  }

  /**
   * Get a LeadList
   * Get a LeadList
   */
  async getListList(
    requestParameters: GetListListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<LeadList> {
    const response = await this.getListListRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Returns all initial values for user, company, config, etc
   * Initial endpoint to hit after oauth
   */
  async getLoginRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<LoginSchema>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/login`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      LoginSchemaFromJSON(jsonValue),
    );
  }

  /**
   * Returns all initial values for user, company, config, etc
   * Initial endpoint to hit after oauth
   */
  async getLogin(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<LoginSchema> {
    const response = await this.getLoginRaw(initOverrides);
    return await response.value();
  }

  /**
   * Bulk fetch entity short keys by comma-delimited url params
   * Bulk fetch entities by short keys
   */
  async getModelsByKeysRaw(
    requestParameters: GetModelsByKeysRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<object>>> {
    const queryParameters: any = {};

    if (requestParameters['silent'] != null) {
      queryParameters['silent'] = requestParameters['silent'];
    }

    if (requestParameters['keys'] != null) {
      queryParameters['keys'] = requestParameters['keys'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/bulk`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Bulk fetch entity short keys by comma-delimited url params
   * Bulk fetch entities by short keys
   */
  async getModelsByKeys(
    requestParameters: GetModelsByKeysRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<object>> {
    const response = await this.getModelsByKeysRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Bulk fetch entities of a single kind by a list of ids or short keys
   * Bulk fetch entities of a single kind by short keys
   */
  async getModelsByKeysOfKindRaw(
    requestParameters: GetModelsByKeysOfKindRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<object>>> {
    if (requestParameters['kind'] == null) {
      throw new runtime.RequiredError(
        'kind',
        'Required parameter "kind" was null or undefined when calling getModelsByKeysOfKind().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['ids'] != null) {
      queryParameters['ids'] = requestParameters['ids'];
    }

    if (requestParameters['keys'] != null) {
      queryParameters['keys'] = requestParameters['keys'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/bulk/{kind}`.replace(
          `{${'kind'}}`,
          encodeURIComponent(String(requestParameters['kind'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Bulk fetch entities of a single kind by a list of ids or short keys
   * Bulk fetch entities of a single kind by short keys
   */
  async getModelsByKeysOfKind(
    requestParameters: GetModelsByKeysOfKindRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<object>> {
    const response = await this.getModelsByKeysOfKindRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Get a list of Operators
   * Get Operator
   */
  async getOperatorRaw(
    requestParameters: GetOperatorRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<Target>>> {
    const queryParameters: any = {};

    if (requestParameters['cached'] != null) {
      queryParameters['cached'] = requestParameters['cached'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/operator`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(TargetFromJSON),
    );
  }

  /**
   * Get a list of Operators
   * Get Operator
   */
  async getOperator(
    requestParameters: GetOperatorRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<Target>> {
    const response = await this.getOperatorRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Get an individual Phone entity
   * Get Phone
   */
  async getPhoneRaw(
    requestParameters: GetPhoneRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Phone>> {
    if (requestParameters['e164'] == null) {
      throw new runtime.RequiredError(
        'e164',
        'Required parameter "e164" was null or undefined when calling getPhone().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/phone/{e164}`.replace(
          `{${'e164'}}`,
          encodeURIComponent(String(requestParameters['e164'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PhoneFromJSON(jsonValue),
    );
  }

  /**
   * Get an individual Phone entity
   * Get Phone
   */
  async getPhone(
    requestParameters: GetPhoneRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Phone> {
    const response = await this.getPhoneRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Get an individual Phone CSV entity
   * Get Phone CSV
   */
  async getPhoneCsvRaw(
    requestParameters: GetPhoneCsvRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PhoneCsv>> {
    if (requestParameters['csvId'] == null) {
      throw new runtime.RequiredError(
        'csvId',
        'Required parameter "csvId" was null or undefined when calling getPhoneCsv().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/phonecsv/{csv_id}`.replace(
          `{${'csv_id'}}`,
          encodeURIComponent(String(requestParameters['csvId'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PhoneCsvFromJSON(jsonValue),
    );
  }

  /**
   * Get an individual Phone CSV entity
   * Get Phone CSV
   */
  async getPhoneCsv(
    requestParameters: GetPhoneCsvRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PhoneCsv> {
    const response = await this.getPhoneCsvRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Get a list of PhoneCsv entities
   * Get List of Phone CSVs
   */
  async getPhoneCsvsRaw(
    requestParameters: GetPhoneCsvsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<PhoneCsv>>> {
    const queryParameters: any = {};

    if (requestParameters['count'] != null) {
      queryParameters['count'] = requestParameters['count'];
    }

    if (requestParameters['keysOnly'] != null) {
      queryParameters['keys_only'] = requestParameters['keysOnly'];
    }

    if (requestParameters['total'] != null) {
      queryParameters['total'] = requestParameters['total'];
    }

    if (requestParameters['cursor'] != null) {
      queryParameters['cursor'] = requestParameters['cursor'];
    }

    if (requestParameters['offset'] != null) {
      queryParameters['offset'] = requestParameters['offset'];
    }

    if (requestParameters['limit'] != null) {
      queryParameters['limit'] = requestParameters['limit'];
    }

    if (requestParameters['targetIds'] != null) {
      queryParameters['target_ids'] = requestParameters['targetIds'];
    }

    if (requestParameters['tag'] != null) {
      queryParameters['tag'] = requestParameters['tag'];
    }

    if (requestParameters['states'] != null) {
      queryParameters['states'] = requestParameters['states'];
    }

    if (requestParameters['state'] != null) {
      queryParameters['state'] = requestParameters['state'];
    }

    if (requestParameters['search'] != null) {
      queryParameters['search'] = requestParameters['search'];
    }

    if (requestParameters['order'] != null) {
      queryParameters['order'] = requestParameters['order'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/phonecsv`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(PhoneCsvFromJSON),
    );
  }

  /**
   * Get a list of PhoneCsv entities
   * Get List of Phone CSVs
   */
  async getPhoneCsvs(
    requestParameters: GetPhoneCsvsRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<PhoneCsv>> {
    const response = await this.getPhoneCsvsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Get a list of phone table for company DNC/DNT
   * List of Phones
   */
  async getPhonesRaw(
    requestParameters: GetPhonesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<Phone>>> {
    const queryParameters: any = {};

    if (requestParameters['count'] != null) {
      queryParameters['count'] = requestParameters['count'];
    }

    if (requestParameters['keysOnly'] != null) {
      queryParameters['keys_only'] = requestParameters['keysOnly'];
    }

    if (requestParameters['total'] != null) {
      queryParameters['total'] = requestParameters['total'];
    }

    if (requestParameters['cursor'] != null) {
      queryParameters['cursor'] = requestParameters['cursor'];
    }

    if (requestParameters['offset'] != null) {
      queryParameters['offset'] = requestParameters['offset'];
    }

    if (requestParameters['limit'] != null) {
      queryParameters['limit'] = requestParameters['limit'];
    }

    if (requestParameters['filters'] != null) {
      queryParameters['filters'] = requestParameters['filters'];
    }

    if (requestParameters['search'] != null) {
      queryParameters['search'] = requestParameters['search'];
    }

    if (requestParameters['order'] != null) {
      queryParameters['order'] = requestParameters['order'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/phone`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(PhoneFromJSON),
    );
  }

  /**
   * Get a list of phone table for company DNC/DNT
   * List of Phones
   */
  async getPhones(
    requestParameters: GetPhonesRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<Phone>> {
    const response = await this.getPhonesRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Get a Rule
   * Get Rule
   */
  async getRuleRaw(
    requestParameters: GetRuleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Rule>> {
    if (requestParameters['ruleId'] == null) {
      throw new runtime.RequiredError(
        'ruleId',
        'Required parameter "ruleId" was null or undefined when calling getRule().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/rule/{rule_id}`.replace(
          `{${'rule_id'}}`,
          encodeURIComponent(String(requestParameters['ruleId'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RuleFromJSON(jsonValue),
    );
  }

  /**
   * Get a Rule
   * Get Rule
   */
  async getRule(
    requestParameters: GetRuleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Rule> {
    const response = await this.getRuleRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * List of rules belonging to a campaign with campaign id
   * List of rules for a campaign
   */
  async getRulesRaw(
    requestParameters: GetRulesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<Rule>>> {
    const queryParameters: any = {};

    if (requestParameters['count'] != null) {
      queryParameters['count'] = requestParameters['count'];
    }

    if (requestParameters['keysOnly'] != null) {
      queryParameters['keys_only'] = requestParameters['keysOnly'];
    }

    if (requestParameters['total'] != null) {
      queryParameters['total'] = requestParameters['total'];
    }

    if (requestParameters['cursor'] != null) {
      queryParameters['cursor'] = requestParameters['cursor'];
    }

    if (requestParameters['offset'] != null) {
      queryParameters['offset'] = requestParameters['offset'];
    }

    if (requestParameters['limit'] != null) {
      queryParameters['limit'] = requestParameters['limit'];
    }

    if (requestParameters['flowId'] != null) {
      queryParameters['flow_id'] = requestParameters['flowId'];
    }

    if (requestParameters['campaignId'] != null) {
      queryParameters['campaign_id'] = requestParameters['campaignId'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/rule`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(RuleFromJSON),
    );
  }

  /**
   * List of rules belonging to a campaign with campaign id
   * List of rules for a campaign
   */
  async getRules(
    requestParameters: GetRulesRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<Rule>> {
    const response = await this.getRulesRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * DEBUG: Get a list of recent sms given a Target
   * Get Sms List for a Target
   */
  async getSmsForTargetRaw(
    requestParameters: GetSmsForTargetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<Sms>>> {
    if (requestParameters['targetType'] == null) {
      throw new runtime.RequiredError(
        'targetType',
        'Required parameter "targetType" was null or undefined when calling getSmsForTarget().',
      );
    }

    if (requestParameters['targetId'] == null) {
      throw new runtime.RequiredError(
        'targetId',
        'Required parameter "targetId" was null or undefined when calling getSmsForTarget().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['count'] != null) {
      queryParameters['count'] = requestParameters['count'];
    }

    if (requestParameters['keysOnly'] != null) {
      queryParameters['keys_only'] = requestParameters['keysOnly'];
    }

    if (requestParameters['total'] != null) {
      queryParameters['total'] = requestParameters['total'];
    }

    if (requestParameters['cursor'] != null) {
      queryParameters['cursor'] = requestParameters['cursor'];
    }

    if (requestParameters['offset'] != null) {
      queryParameters['offset'] = requestParameters['offset'];
    }

    if (requestParameters['limit'] != null) {
      queryParameters['limit'] = requestParameters['limit'];
    }

    if (requestParameters['targetType'] != null) {
      queryParameters['target_type'] = requestParameters['targetType'];
    }

    if (requestParameters['targetId'] != null) {
      queryParameters['target_id'] = requestParameters['targetId'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/sms`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(SmsFromJSON),
    );
  }

  /**
   * DEBUG: Get a list of recent sms given a Target
   * Get Sms List for a Target
   */
  async getSmsForTarget(
    requestParameters: GetSmsForTargetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<Sms>> {
    const response = await this.getSmsForTargetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Auto-complete variable info belonging to a campaign with campaign id
   * Get auto-complete variable info
   */
  async getVarsInfoRaw(
    requestParameters: GetVarsInfoRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['campaignId'] == null) {
      throw new runtime.RequiredError(
        'campaignId',
        'Required parameter "campaignId" was null or undefined when calling getVarsInfo().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/vars_info/{campaign_id}`.replace(
          `{${'campaign_id'}}`,
          encodeURIComponent(String(requestParameters['campaignId'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Auto-complete variable info belonging to a campaign with campaign id
   * Get auto-complete variable info
   */
  async getVarsInfo(
    requestParameters: GetVarsInfoRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.getVarsInfoRaw(requestParameters, initOverrides);
  }

  /**
   * Get a Worker
   * Get a Worker
   */
  async getWorkerRaw(
    requestParameters: GetWorkerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Worker>> {
    if (requestParameters['workerId'] == null) {
      throw new runtime.RequiredError(
        'workerId',
        'Required parameter "workerId" was null or undefined when calling getWorker().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/worker/{worker_id}`.replace(
          `{${'worker_id'}}`,
          encodeURIComponent(String(requestParameters['workerId'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      WorkerFromJSON(jsonValue),
    );
  }

  /**
   * Get a Worker
   * Get a Worker
   */
  async getWorker(
    requestParameters: GetWorkerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Worker> {
    const response = await this.getWorkerRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Get a list of Workers for a Campaign
   * Get Workers
   */
  async getWorkersRaw(
    requestParameters: GetWorkersRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<Worker>>> {
    const queryParameters: any = {};

    if (requestParameters['campaignId'] != null) {
      queryParameters['campaign_id'] = requestParameters['campaignId'];
    }

    if (requestParameters['tags'] != null) {
      queryParameters['tags'] = requestParameters['tags'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/worker`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(WorkerFromJSON),
    );
  }

  /**
   * Get a list of Workers for a Campaign
   * Get Workers
   */
  async getWorkers(
    requestParameters: GetWorkersRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<Worker>> {
    const response = await this.getWorkersRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Generic hook for receiving requests from Hubspot etc
   * External Hook Endpoint
   */
  async hookCallbackRaw(
    requestParameters: HookCallbackRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<HookSchema>> {
    const queryParameters: any = {};

    if (requestParameters['campaignId'] != null) {
      queryParameters['campaign_id'] = requestParameters['campaignId'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/hook`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      HookSchemaFromJSON(jsonValue),
    );
  }

  /**
   * Generic hook for receiving requests from Hubspot etc
   * External Hook Endpoint
   */
  async hookCallback(
    requestParameters: HookCallbackRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<HookSchema> {
    const response = await this.hookCallbackRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * DEBUG: Send a text message through dialpad for a given LeadListItem
   * Send SMS
   */
  async smsItemRaw(
    requestParameters: SmsItemRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<LeadListItem>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/api/sms`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: SmsPostRequestToJSON(requestParameters['smsPostRequest']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      LeadListItemFromJSON(jsonValue),
    );
  }

  /**
   * DEBUG: Send a text message through dialpad for a given LeadListItem
   * Send SMS
   */
  async smsItem(
    requestParameters: SmsItemRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<LeadListItem> {
    const response = await this.smsItemRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Start a campaign result export job
   * Start a campaign result export job
   */
  async startCampaignResultExportRaw(
    requestParameters: StartCampaignResultExportRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['campaignId'] == null) {
      throw new runtime.RequiredError(
        'campaignId',
        'Required parameter "campaignId" was null or undefined when calling startCampaignResultExport().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/campaign_export/{campaign_id}`.replace(
          `{${'campaign_id'}}`,
          encodeURIComponent(String(requestParameters['campaignId'])),
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Start a campaign result export job
   * Start a campaign result export job
   */
  async startCampaignResultExport(
    requestParameters: StartCampaignResultExportRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.startCampaignResultExportRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Update a Campaign like starting, resetting, etc
   * Update Campaign
   */
  async updateCampaignRaw(
    requestParameters: UpdateCampaignRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Campaign>> {
    if (requestParameters['campaignId'] == null) {
      throw new runtime.RequiredError(
        'campaignId',
        'Required parameter "campaignId" was null or undefined when calling updateCampaign().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/api/campaign/{campaign_id}`.replace(
          `{${'campaign_id'}}`,
          encodeURIComponent(String(requestParameters['campaignId'])),
        ),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: CampaignPatchToJSON(requestParameters['campaignPatch']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CampaignFromJSON(jsonValue),
    );
  }

  /**
   * Update a Campaign like starting, resetting, etc
   * Update Campaign
   */
  async updateCampaign(
    requestParameters: UpdateCampaignRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Campaign> {
    const response = await this.updateCampaignRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Update a CSV with a mapping, labels, name, etc
   * Update CSV
   */
  async updateCsvRaw(
    requestParameters: UpdateCsvRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Csv>> {
    if (requestParameters['csvId'] == null) {
      throw new runtime.RequiredError(
        'csvId',
        'Required parameter "csvId" was null or undefined when calling updateCsv().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/api/csv/{csv_id}`.replace(
          `{${'csv_id'}}`,
          encodeURIComponent(String(requestParameters['csvId'])),
        ),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: CsvPatchToJSON(requestParameters['csvPatch']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CsvFromJSON(jsonValue),
    );
  }

  /**
   * Update a CSV with a mapping, labels, name, etc
   * Update CSV
   */
  async updateCsv(
    requestParameters: UpdateCsvRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Csv> {
    const response = await this.updateCsvRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Update company GlobalSettings entity
   * Update Company GlobalSettings
   */
  async updateGlobalSettingsRaw(
    requestParameters: UpdateGlobalSettingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<GlobalSettings>> {
    if (requestParameters['companyId'] == null) {
      throw new runtime.RequiredError(
        'companyId',
        'Required parameter "companyId" was null or undefined when calling updateGlobalSettings().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/api/globalsettings/{company_id}`.replace(
          `{${'company_id'}}`,
          encodeURIComponent(String(requestParameters['companyId'])),
        ),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: GlobalSettingsPatchToJSON(
          requestParameters['globalSettingsPatch'],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GlobalSettingsFromJSON(jsonValue),
    );
  }

  /**
   * Update company GlobalSettings entity
   * Update Company GlobalSettings
   */
  async updateGlobalSettings(
    requestParameters: UpdateGlobalSettingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<GlobalSettings> {
    const response = await this.updateGlobalSettingsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Update a Lead
   * Update Lead
   */
  async updateLeadRaw(
    requestParameters: UpdateLeadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Lead>> {
    if (requestParameters['leadId'] == null) {
      throw new runtime.RequiredError(
        'leadId',
        'Required parameter "leadId" was null or undefined when calling updateLead().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/api/lead/{lead_id}`.replace(
          `{${'lead_id'}}`,
          encodeURIComponent(String(requestParameters['leadId'])),
        ),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: LeadPatchToJSON(requestParameters['leadPatch']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      LeadFromJSON(jsonValue),
    );
  }

  /**
   * Update a Lead
   * Update Lead
   */
  async updateLead(
    requestParameters: UpdateLeadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Lead> {
    const response = await this.updateLeadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Update a LeadList with csv_ids, audience_ids, etc
   * Update LeadList
   */
  async updateLeadListRaw(
    requestParameters: UpdateLeadListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<LeadList>> {
    if (requestParameters['listId'] == null) {
      throw new runtime.RequiredError(
        'listId',
        'Required parameter "listId" was null or undefined when calling updateLeadList().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/api/list/{list_id}`.replace(
          `{${'list_id'}}`,
          encodeURIComponent(String(requestParameters['listId'])),
        ),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: LeadListPatchToJSON(requestParameters['leadListPatch']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      LeadListFromJSON(jsonValue),
    );
  }

  /**
   * Update a LeadList with csv_ids, audience_ids, etc
   * Update LeadList
   */
  async updateLeadList(
    requestParameters: UpdateLeadListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<LeadList> {
    const response = await this.updateLeadListRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Update a Phone DNC/DNT statuses
   * Update Phone
   */
  async updatePhoneRaw(
    requestParameters: UpdatePhoneRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Phone>> {
    if (requestParameters['e164'] == null) {
      throw new runtime.RequiredError(
        'e164',
        'Required parameter "e164" was null or undefined when calling updatePhone().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/api/phone/{e164}`.replace(
          `{${'e164'}}`,
          encodeURIComponent(String(requestParameters['e164'])),
        ),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: PhonePostToJSON(requestParameters['phonePost']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PhoneFromJSON(jsonValue),
    );
  }

  /**
   * Update a Phone DNC/DNT statuses
   * Update Phone
   */
  async updatePhone(
    requestParameters: UpdatePhoneRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Phone> {
    const response = await this.updatePhoneRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Update a Phone CSV with a mapping, labels, name, etc
   * Update Phone CSV
   */
  async updatePhoneCsvRaw(
    requestParameters: UpdatePhoneCsvRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PhoneCsv>> {
    if (requestParameters['csvId'] == null) {
      throw new runtime.RequiredError(
        'csvId',
        'Required parameter "csvId" was null or undefined when calling updatePhoneCsv().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/api/phonecsv/{csv_id}`.replace(
          `{${'csv_id'}}`,
          encodeURIComponent(String(requestParameters['csvId'])),
        ),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: PhoneCsvPatchToJSON(requestParameters['phoneCsvPatch']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PhoneCsvFromJSON(jsonValue),
    );
  }

  /**
   * Update a Phone CSV with a mapping, labels, name, etc
   * Update Phone CSV
   */
  async updatePhoneCsv(
    requestParameters: UpdatePhoneCsvRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PhoneCsv> {
    const response = await this.updatePhoneCsvRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Update a rule for a campaign
   * Update a rule for a campaign
   */
  async updateRuleRaw(
    requestParameters: UpdateRuleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Rule>> {
    if (requestParameters['ruleId'] == null) {
      throw new runtime.RequiredError(
        'ruleId',
        'Required parameter "ruleId" was null or undefined when calling updateRule().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/api/rule/{rule_id}`.replace(
          `{${'rule_id'}}`,
          encodeURIComponent(String(requestParameters['ruleId'])),
        ),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: RulePatchToJSON(requestParameters['rulePatch']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RuleFromJSON(jsonValue),
    );
  }

  /**
   * Update a rule for a campaign
   * Update a rule for a campaign
   */
  async updateRule(
    requestParameters: UpdateRuleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Rule> {
    const response = await this.updateRuleRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Update a Worker
   * Update Worker
   */
  async updateWorkerRaw(
    requestParameters: UpdateWorkerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Worker>> {
    if (requestParameters['workerId'] == null) {
      throw new runtime.RequiredError(
        'workerId',
        'Required parameter "workerId" was null or undefined when calling updateWorker().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/api/worker/{worker_id}`.replace(
          `{${'worker_id'}}`,
          encodeURIComponent(String(requestParameters['workerId'])),
        ),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: WorkerPatchRequestToJSON(requestParameters['workerPatchRequest']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      WorkerFromJSON(jsonValue),
    );
  }

  /**
   * Update a Worker
   * Update Worker
   */
  async updateWorker(
    requestParameters: UpdateWorkerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Worker> {
    const response = await this.updateWorkerRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Upload a CSV and create a Csv entity
   * Upload CSV
   */
  async uploadCsvRaw(
    requestParameters: UploadCsvRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Csv>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const consumes: runtime.Consume[] = [
      { contentType: 'multipart/form-data' },
    ];
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): any };
    let useForm = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new URLSearchParams();
    }

    if (requestParameters['file'] != null) {
      formParams.append('file', requestParameters['file'] as any);
    }

    if (requestParameters['name'] != null) {
      formParams.append('name', requestParameters['name'] as any);
    }

    const response = await this.request(
      {
        path: `/api/csv`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: formParams,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CsvFromJSON(jsonValue),
    );
  }

  /**
   * Upload a CSV and create a Csv entity
   * Upload CSV
   */
  async uploadCsv(
    requestParameters: UploadCsvRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Csv> {
    const response = await this.uploadCsvRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Upload a CSV to update Phone table and create a PhoneCsv entity
   * Upload Phone CSV
   */
  async uploadPhoneCsvRaw(
    requestParameters: UploadPhoneCsvRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PhoneCsv>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const consumes: runtime.Consume[] = [
      { contentType: 'multipart/form-data' },
    ];
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): any };
    let useForm = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new URLSearchParams();
    }

    if (requestParameters['file'] != null) {
      formParams.append('file', requestParameters['file'] as any);
    }

    if (requestParameters['name'] != null) {
      formParams.append('name', requestParameters['name'] as any);
    }

    const response = await this.request(
      {
        path: `/api/phonecsv`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: formParams,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PhoneCsvFromJSON(jsonValue),
    );
  }

  /**
   * Upload a CSV to update Phone table and create a PhoneCsv entity
   * Upload Phone CSV
   */
  async uploadPhoneCsv(
    requestParameters: UploadPhoneCsvRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PhoneCsv> {
    const response = await this.uploadPhoneCsvRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}

/**
 * @export
 */
export const GetAudiencesStateEnum = {
  Pending: 'pending',
  Launching: 'launching',
  Scheduled: 'scheduled',
  Active: 'active',
  Paused: 'paused',
  Complete: 'complete',
  Error: 'error',
  Deleted: 'deleted',
} as const;
export type GetAudiencesStateEnum =
  (typeof GetAudiencesStateEnum)[keyof typeof GetAudiencesStateEnum];
/**
 * @export
 */
export const GetCampaignsStateEnum = {
  Pending: 'pending',
  Launching: 'launching',
  Scheduled: 'scheduled',
  Active: 'active',
  Paused: 'paused',
  Complete: 'complete',
  Error: 'error',
  Deleted: 'deleted',
  All: 'all',
  Visible: 'visible',
  Archived: 'archived',
} as const;
export type GetCampaignsStateEnum =
  (typeof GetCampaignsStateEnum)[keyof typeof GetCampaignsStateEnum];
/**
 * @export
 */
export const GetCsvsTagEnum = {
  Pending: 'pending',
  Launching: 'launching',
  Scheduled: 'scheduled',
  Active: 'active',
  Paused: 'paused',
  Complete: 'complete',
  Error: 'error',
  Deleted: 'deleted',
  All: 'all',
  Visible: 'visible',
  Archived: 'archived',
} as const;
export type GetCsvsTagEnum =
  (typeof GetCsvsTagEnum)[keyof typeof GetCsvsTagEnum];
/**
 * @export
 */
export const GetCsvsStateEnum = {
  Pending: 'pending',
  Launching: 'launching',
  Scheduled: 'scheduled',
  Active: 'active',
  Paused: 'paused',
  Complete: 'complete',
  Error: 'error',
  Deleted: 'deleted',
} as const;
export type GetCsvsStateEnum =
  (typeof GetCsvsStateEnum)[keyof typeof GetCsvsStateEnum];
/**
 * @export
 */
export const GetPhoneCsvsTagEnum = {
  Pending: 'pending',
  Launching: 'launching',
  Scheduled: 'scheduled',
  Active: 'active',
  Paused: 'paused',
  Complete: 'complete',
  Error: 'error',
  Deleted: 'deleted',
  All: 'all',
  Visible: 'visible',
  Archived: 'archived',
} as const;
export type GetPhoneCsvsTagEnum =
  (typeof GetPhoneCsvsTagEnum)[keyof typeof GetPhoneCsvsTagEnum];
/**
 * @export
 */
export const GetPhoneCsvsStateEnum = {
  Pending: 'pending',
  Launching: 'launching',
  Scheduled: 'scheduled',
  Active: 'active',
  Paused: 'paused',
  Complete: 'complete',
  Error: 'error',
  Deleted: 'deleted',
} as const;
export type GetPhoneCsvsStateEnum =
  (typeof GetPhoneCsvsStateEnum)[keyof typeof GetPhoneCsvsStateEnum];
